import React, { useState, useEffect } from "react";

const CopyModal = ({ isOpen, onClose, onSave, selected, pages }) => {
  const [formData, setFormData] = useState({
    pageSelection: "", // Value for selected page
  });

  const [pageIds, setPageIds] = useState([]);

  useEffect(() => {
    if (selected) {
      // Initialize formData with selected values if necessary
      setFormData({
        pageSelection: selected.pageSelection || "",
      });
    }

    let ids = new Map();
    if (pages?.length > 0) {
      pages.forEach(page => {
        const pageId = page.pageId;
        ids.set(pageId, page.pageId); // Keep the full pageId internally
      });
      setPageIds(Array.from(ids.values()));
    }
  }, [selected, pages]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    // selected.pageSelection = formData.pageSelection;

    if (onSave) onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  const styles = {
    backdrop: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 50,
    },
    modal: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    },
    label: { display: "block", marginBottom: "10px", fontSize: "14px" },
    input: {
      display: "block",
      width: "100%",
      padding: "6px 10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    modalButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "6px 12px",
      fontSize: "14px",
      borderRadius: "4px",
      border: "none",
      cursor: "pointer",
    },
    cancel: { backgroundColor: "#e0e0e0" },
    save: { backgroundColor: "#007bff", color: "#fff" },
    section: {
      marginBottom: "20px",
      padding: "10px",
      backgroundColor: "#f9f9f9",
      borderRadius: "6px",
      border: "1px solid #ddd",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "10px",
    },
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h2>Copy Page From</h2>

        {/* Page Selection Section */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Select Page</div>
          <select
            value={formData.pageSelection}
            onChange={(e) => handleChange("pageSelection", e.target.value)}
            style={styles.input}
          >
            <option value="">Select a page</option>
            {pageIds.map((pageId) => {
              const [root, num] = pageId.split("_");
              const displayId = root.slice(-5); // Get last 5 characters before the underscore
              return (
                <option key={pageId} value={pageId}>
                  {displayId}_{num} {/* Show last 5 characters and the part after the underscore */}
                </option>
              );
            })}
          </select>
        </div>

        {/* Modal Buttons */}
        <div style={styles.modalButtons}>
          <button style={{ ...styles.button, ...styles.cancel }} onClick={onClose}>
            Cancel
          </button>
          <button style={{ ...styles.button, ...styles.save }} onClick={handleSave}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default CopyModal;


